// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerHeader__eqNVH {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.25rem;
}

@media (max-width: 768px) {
  .styles_containerHeader__eqNVH {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AjustesVerbas/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".containerHeader {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 0.25rem;\n}\n\n@media (max-width: 768px) {\n  .containerHeader {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerHeader": `styles_containerHeader__eqNVH`
};
export default ___CSS_LOADER_EXPORT___;
